import { getCareerAvailableYears } from "../lib/cvDataUtilities.js";
import { formatDate, getDate, getYears } from "../lib/dateHelpers.js";
import { escapeHtml, getProp } from "../lib/frontendUtilities.js";
import { getLastPosition } from "../lib/reportUtilities.js";
import { getKey, keys } from "../lib/utilities.js";
import { CCManage } from "./cclib/CCManage.ts";

var sortBy = "mentor";
var mentees = [];
// let ccManage;

var mghEmStructure = [
  {
    sections: [
      {
        name: "Please rank the following activities according to your present commitment (1 - most, 5 - least)",
        list: [
          { name: "Patient Care", key: "rank1", edit: "mentee" },
          { name: "Teaching", key: "rank2", edit: "mentee" },
          { name: "Research", key: "rank3", edit: "mentee" },
          { name: "Admin / Committee Work", key: "rank4", edit: "mentee" },
          { name: "Other", key: "rank5", edit: "mentee" },
          {
            name: "What were your 2-3 most important goals for last year?",
            type: "paragraph",
            key: "lastGoals",
            edit: "mentee"
          },
          {
            name: "List your 2-3 most significant accomplishments for last year.",
            type: "paragraph",
            key: "accomplishments",
            edit: "mentee"
          }
        ]
      },
      {
        name: "Academic career aspirations",
        list: [
          {
            name: "Which of the following area of excellence do you think you meet?",
            key: "areaOfExcellence",
            type: "select",
            options: [
              "Not selected",
              "Teaching and Educational Leadership",
              "Clinical Expertise and Innovation",
              "Investigation",
              "I am not sure"
            ],
            edit: "mentee"
          },
          {
            name: "Do you understand the HMS promotion criteria for advancement in your area of excellence specified above?",
            key: "criteriaUnderstanding",
            type: "select",
            allowOther: true,
            otherName: "No, please explain",
            options: ["Yes"],
            edit: "mentee"
          },
          {
            name: "Are we providing you the resources to succeed in your job?",
            key: "resources",
            type: "paragraph",
            edit: "mentee"
          },
          {
            name: "Are there any activities in which you wish to spend - More time",
            key: "wantMore",
            type: "paragraph",
            edit: "mentee"
          },
          {
            name: "Are there any activities in which you wish to spend - Less time",
            key: "wantLess",
            type: "paragraph",
            edit: "mentee"
          },
          {
            name: "List your current mentors, if any, and how effectiveness could be improved.",
            key: "currMentors",
            type: "paragraph",
            edit: "mentee"
          },
          {
            name: "List those you have mentored, if any.",
            key: "currMentees",
            type: "paragraph",
            edit: "mentee"
          },
          {
            name: "List your 2-3 goals for the upcoming year.",
            key: "nextGoals",
            type: "paragraph",
            edit: "mentee"
          },
          {
            name: "Are you interested in leadership opportunities?",
            key: "leadershipInterest",
            type: "paragraph",
            edit: "mentee"
          },
          {
            name: "Is there something you are doing or would like to do in your research or clinical practice that is innovative that we should consider/discuss as you think about your career?",
            key: "innovation",
            type: "paragraph",
            edit: "mentee"
          },
          {
            name: "What specific activity(ies) do you do that brings you particular satisfaction?",
            placeholder: "Research, mentoring, innovation",
            key: "satisfaction",
            type: "paragraph",
            edit: "mentee"
          },
          {
            name: "What are the opportunities to increase this activity (these activities) over the next year?",
            key: "incOpportunities",
            type: "paragraph",
            edit: "mentee"
          }
        ]
      },
      {
        name: "At the conference, the Chief or Division Chief should fill out this portion of the form with faculty member.",
        edit: "mentor",
        list: [
          {
            name: "Future Considerations (e.g. Career/Opportunities/Professional/Retirement/Transitions)",
            placeholder: "1)\n2)\n3)\n4)",
            key: "futureConsiderations",
            type: "paragraph",
            edit: "mentor"
          }
        ]
      },
      {
        name: "The considerations above will require",
        edit: "mentor",
        list: [
          {
            name: "- Additional training",
            key: "reqTraining",
            type: "paragraph",
            edit: "mentor"
          },
          {
            name: "- Re-allocation/Reduction of time and effort to teaching, clinical, scholarship and service",
            key: "reqTime",
            type: "paragraph",
            edit: "mentor"
          },
          {
            name: "- Resources",
            key: "reqResources",
            type: "paragraph",
            edit: "mentor"
          },
          {
            name: "- Referral to others (e.g. Benefits Office, Employee Assistance Program, etc.)",
            key: "reqReferral",
            type: "paragraph",
            edit: "mentor"
          },
          {
            name: "In addition, I have provided specific counsel regarding",
            key: "specCounsel",
            type: "paragraph",
            edit: "mentor"
          },
          {
            name: "Is there anything else that is affecting you that you would like to discuss?",
            key: "otherDiscussion",
            type: "paragraph",
            edit: "mentor"
          }
        ]
      }
    ]
  }
];

export default {
  title: "MGH EM",
  cvSetup: function ({
    contextMethods,
    contextConstants,
    contextState,
    conference,
    backend
  }) {
    let { refreshSection, updateLayout, checkSave } = contextMethods;
    let { user, cvOwner, users, mentors, conferences } = contextConstants;
    let {
      section,
      sectionState,
      format,
      newDef,
      viewAsState,
      customExportSettings
    } = contextState;

    var editAccessOverride =
      (user.settings.accessFilters || []).length > 0 &&
      user.settings.conferenceTabAccess == "editAccess";
    var menteeOverride = false;
    var mentorOverride = false;

    var menteeAccess =
      user.id == cvOwner.id || editAccessOverride || menteeOverride;
    var overviewState = getKey(sectionState, section, {});

    var mentorAccess =
      (conference.mentors[user.id] || {})[cvOwner.id] != null ||
      editAccessOverride ||
      mentorOverride;
    var managerAccess = editAccessOverride;

    $("#fieldList").empty();

    $("#fieldList").append(
      $(
        "" +
          "<div>" +
          '   <div class="btn btn-default careerYearPrev" style="margin-right: 15px; margin-bottom: 8px;">' +
          '   <span class="glyphicon glyphicon-arrow-left"></span>' +
          "   </div>" +
          '   <h4 class="careerYear" style="margin-right: 15px;display: inline-block;margin-top: 7px;vertical-align: top;">Year: </h4>' +
          '   <div class="btn btn-default careerYearNext" style="margin-right: 15px;vertical-align: top;"><span class="glyphicon glyphicon-arrow-right"></span></div>' +
          '   <div class="btn btn-primary limitedCVCareerDownload" style="position: relative; margin-right: 5px; vertical-align: top; display: inline-block;">' +
          '     <span class="glyphicon glyphicon-download" style="margin-right: 5px;"></span>' +
          "     <span>Date Limited CV</span>" +
          "   </div>" +
          '   <div class="btn btn-primary fullDownload" style="position: relative; margin-right: 5px; vertical-align: top; display: inline-block;">' +
          '     <span class="glyphicon glyphicon-download" style="margin-right: 5px;"></span>' +
          "     <span>Full CV</span>" +
          "   </div>" +
          '   <div class="btn btn-primary careerReportPrint" style="position: relative; margin-right: 5px; vertical-align: top; display: inline-block;">' +
          '     <span class="glyphicon glyphicon-print" style="margin-right: 5px;"></span>' +
          "     <span>Print</span>" +
          "   </div>" +
          " </div>"
      )
    );

    $(".careerReportPrint")
      .unbind("click")
      .click(function () {
        updateHTML({ readOnly: true });
        var printContents = $("#printableContents")[0].innerHTML;
        var w = window.open("", "Test");
        w.document.write(
          '<link rel="stylesheet" href="/css/bootstrap.min.css"/>'
        );
        w.document.write(
          "<style> @media print {  @page { margin: 1in; } } </style>"
        );
        var yearRange = $(".careerYear").text();
        w.document.write(
          '<div style="padding: 15px;"><h4 style="">' +
            yearRange +
            " " +
            (cvOwner.name || "") +
            " Career Conference</h4>" +
            printContents +
            "</div>"
        );
        updateHTML();
        w.document.title =
          yearRange + " " + (cvOwner.name || "") + " Career Conference";
        setTimeout(function () {
          w.print();
          // w.close();
        }, 1000);
      });

    $(".limitedCVCareerDownload")
      .unbind("click")
      .click(function () {
        var overviewState = getKey(sectionState, section, {});

        var yearInfo = getCareerAvailableYears(
          newDef,
          conference,
          user,
          cvOwner
        );
        var availableYears = yearInfo.availableYears;
        var baseYear = yearInfo.baseYear;
        if (
          overviewState.yearIndex == null ||
          availableYears[overviewState.yearIndex] == null
        )
          overviewState.yearIndex = availableYears.findIndex(function (n) {
            return n == baseYear;
          });
        var viewYear = availableYears[overviewState.yearIndex];

        var cutoff = conference.cutoffDate || "1/1"; // Before this = last year. New section starts on this date
        var month = cutoff.split("/")[0] || "1";
        var date = cutoff.split("/")[1] || "1";

        customExportSettings.dateLimited = true;
        customExportSettings.shown = true;

        var endDate = new Date(
          viewYear + 1,
          parseInt(month) - 1,
          parseInt(date) - 1
        );
        $("#m1").val(month);
        $("#m2").val(endDate.getMonth() + 1);
        $("#d1").val(date);
        $("#d2").val(endDate.getDate());
        $("#y1").val(viewYear + (format == "stanford_anesthesia" ? -1 : 0));
        $("#y2").val(endDate.getYear() + 1900);
        $(".download").trigger("click");
      });

    var mentorList = keys(conference.mentors).filter(function (id) {
      return conference.mentors[id][cvOwner.id] != null && mentors[id] != null;
    });

    if (mentorList.length > 0) {
      $("#fieldList").append(
        $(
          "" +
            '<div id="confSelectSection" style="margin-bottom: 10px;display: inline-block;width: 100%;">' +
            '  <h4 style="display: inline-block;margin-right: 5px;">Career Conference Mentor' +
            (mentorList.length > 1 ? "s" : "") +
            ": " +
            mentorList
              .map(function (mId) {
                return escapeHtml(mentors[mId].name);
              })
              .join(", ") +
            "</h4>" +
            "</div>"
        )
      );
    }

    $("#fieldList").append(
      $(
        "" +
          '<div style="margin-top: 8px;display: inline-block;width: 100%;">' +
          '  <h4 class="statusTitle" style="display: inline-block; margin-right: 5px;">Status: Mentee Editing</h4>' +
          '  <div class="btn nextStatus btn-success" style="vertical-align: top;margin-top: 3px;"></div>' +
          '  <div class="btn prevStatus btn-default" style="vertical-align: top;margin-top: 3px;"></div>' +
          '  <h5 class="errorSubheader" style="color: #ad310e;">Missing Information Required Before Submission</h5>' +
          '  <h5 class="statusSubheader">When finished, mark as complete to notify your mentor.</h5>' +
          "</div>"
      )
    );

    var last = getLastPosition(newDef, { format });
    if (
      last != null &&
      last.time != null &&
      last.time.start != null &&
      !isNaN(getYears(last.time.start))
    ) {
      var dateText = getDate(last);
      var yearsLong = Math.round(last.years * 10) / 10; // Math.round(((last.time.end != null && last.time.end != 'ongoing') ? getYears(last.time.end) : (new Date().getYear()+1900)) - getYears(last.time.start));
      $("#fieldList").append(
        $(
          "" +
            '<div style="margin-bottom: 10px;margin-top: 10px;">' +
            '  <h4 style="margin-bottom: 10px; display: inline-block;">Academic Title: <span id="careerConfCurrentTitle"><u class="sectionTab" data-section="facultyAppointments">' +
            escapeHtml(last.title) +
            " (" +
            escapeHtml(dateText) +
            ")</u> for " +
            yearsLong +
            " year" +
            (yearsLong != 1 ? "s" : "") +
            "</span></h4>" +
            "<div>"
        )
      );
    }

    var printableContents = $('<span id="printableContents"></span>');
    $("#fieldList").append(printableContents);

    // Find which years are available. Should be just years which have data or which are open, or if you have mentorAccess
    var yearInfo = getCareerAvailableYears(newDef, conference, user, cvOwner);
    var availableYears = yearInfo.availableYears;
    var baseYear = yearInfo.baseYear;

    var overviewState = getKey(sectionState, section, {});
    if (
      overviewState.yearIndex == null ||
      availableYears[overviewState.yearIndex] == null
    )
      overviewState.yearIndex = availableYears.findIndex(function (n) {
        return n == baseYear;
      });

    if (overviewState.mghEmTab == null) overviewState.mghEmTab = 0;
    var mghEmTab = mghEmStructure[overviewState.mghEmTab];

    // printableContents.append($('<h5 style="margin-bottom: 10px;display: inline-block;margin-top: 20px;margin-right: 5px;">Section:</h5><select class="form-control" style="display: inline-block;width: auto;height: 30px;margin-right: 10px;"><option>Research</option></select><h5 style="display: inline-block;">Total points: <span id="APAW_totalPoints"></span></h5>'));

    printableContents.append($('<div id="MGH_EM_section"></div>'));

    printableContents.append(
      $(
        "" +
          `<div id="mghEmSignSection">
<div style="margin-bottom: 5px;">
<h4 id="mghEmSignChairLine" style="display: inline-block;margin-right: 10px; font-weight: normal;"><b>Signature of Mentor: </b><i>(Not Yet Signed)</i></h4><div id="mghEmSignChairButton" class="btn btn-success">Digitally Sign</div>
</div>
<div style="margin-bottom: 5px;">
<h4 id="mghEmSignMenteeLine" style="display: inline-block;margin-right: 10px; font-weight: normal;"><b>Signature of Faculty Member: </b></h4><div id="mghEmSignMenteeButton" class="btn btn-success">Digitally Sign</div>
</div>
</div>`
      )
    );

    $("#fieldList").append(
      $(
        "" +
          '<div style="margin-top: 8px;display: inline-block;width: 100%;">' +
          '  <h4 class="statusTitle" style="display: inline-block; margin-right: 5px;">Status: Mentee Editing</h4>' +
          '  <div class="btn nextStatus btn-success disabled" style="vertical-align: top; margin-top: 3px; display: inline-block;">Submit for Review</div>' +
          '  <div class="btn prevStatus btn-default" style="vertical-align: top; margin-top: 3px; display: none;"></div>' +
          '  <h5 class="errorSubheader" style="color: #ad310e;"></h5>' +
          '  <h5 class="statusSubheader" style="display: none;">When finished, submit for review to notify your mentor</h5>' +
          "</div>"
      )
    );

    var careerErrorCheck = function () {
      var overviewState = getKey(sectionState, section, {});
      // if (overviewState.yearIndex == null) overviewState.yearIndex = 0;
      if (
        overviewState.yearIndex == null ||
        availableYears[overviewState.yearIndex] == null
      )
        overviewState.yearIndex = availableYears.findIndex(function (n) {
          return n == baseYear;
        });
      var viewYear = availableYears[overviewState.yearIndex];

      var yearData = getKey(newDef.career, viewYear, {
        timeBreakdown: {},
        goals: {},
        status: "mentee",
        questions: {},
        mentorComments: ""
      });

      var confYearData = conference.openYears[viewYear] || { open: false };
      var isOpen = !!confYearData.open || managerAccess; // For managers, it's always open.

      var errors = [];
      var hasError = false;

      if (!isOpen) {
        $(".statusSubheader").text("");
        $(".errorSubheader").text("");
      } else if (yearData.status == "mentee" && menteeAccess) {
        $(".statusSubheader").text(
          "When finished, submit for review to notify your mentor"
        );
        $(".errorSubheader").text(errors.join(", "));
      } else if (yearData.status == "mentor" && mentorAccess) {
        $(".statusSubheader").text("When finished, mark as finalized");
        $(".errorSubheader").text(
          "Missing information required before finalizing"
        );
      } else {
        $(".statusSubheader").text("");
        $(".errorSubheader").text("");
      }

      $(".statusSubheader").toggle(!hasError);
      $(".errorSubheader").toggle(hasError);

      $(".errorSubheader")
        .unbind("click")
        .click(function () {
          $(".has-error")[0].scrollIntoView();
        });
      $(".nextStatus").toggleClass("disabled", hasError);
    };

    var updateHTML = function (opts) {
      opts = opts || {};
      var overviewState = getKey(sectionState, section, {});
      // if (overviewState.yearIndex == null) overviewState.yearIndex = 0;
      if (
        overviewState.yearIndex == null ||
        availableYears[overviewState.yearIndex] == null
      )
        overviewState.yearIndex = availableYears.findIndex(function (n) {
          return n == baseYear;
        });
      var viewYear = availableYears[overviewState.yearIndex];

      var cutoff = conference.cutoffDate || "1/1"; // Before this = last year. New section starts on this date
      var month = cutoff.split("/")[0] || "1";
      var date = cutoff.split("/")[1] || "1";

      var startDate = new Date(month + "/" + date + "/" + viewYear).getTime();
      var endDate =
        new Date(month + "/" + date + "/" + (viewYear + 1)).getTime() -
        1000 * 60 * 60 * 24;

      var yearData = getKey(newDef.career, viewYear, {
        timeBreakdown: {},
        goals: {},
        status: "mentee",
        questions: {},
        mentorComments: "",
        details: {}
      });

      getKey(yearData, "status", "mentee"); // mentee, mentor, finalized

      var confYearData = conference.openYears[viewYear] || { open: false };
      var isOpen = !!confYearData.open || managerAccess;

      $("#mghEmSignSection").toggle(
        ["finalized"].indexOf(yearData.status) >= 0
      );

      var isReadOnly = function (yearData, type, thisOpts) {
        thisOpts = thisOpts || {};
        if (opts.readOnly) return true;
        var editAccessOverride =
          (user.settings.accessFilters || []).length > 0 &&
          user.settings.conferenceTabAccess == "editAccess";
        if (thisOpts.noOverride) editAccessOverride = false;
        var menteeOverride = false;
        var mentorOverride = false;

        if (viewAsState !== "undefined" && editAccessOverride) {
          editAccessOverride = false;
          if (viewAsState.career == "mentee") menteeOverride = true;
          else if (viewAsState.career == "mentor") mentorOverride = true;
          else editAccessOverride = true;
        }

        var menteeAccess =
          user.id == cvOwner.id || editAccessOverride || menteeOverride;
        var mentorAccess =
          (conference.mentors[user.id] || {})[cvOwner.id] != null ||
          editAccessOverride ||
          mentorOverride;
        return (
          !isOpen ||
          (yearData.status != type && !mentorAccess && !thisOpts.noOverride) ||
          (type == "mentee" && !menteeAccess) ||
          (type == "mentor" && !mentorAccess)
        );
      };

      $(".generalMentorCommentSection").toggle(
        isOpen &&
          (yearData.status != "mentee" ||
            mentorAccess ||
            (yearData.mentorComments || "").length > 0)
      );

      $(".statusTitle").text(
        "Status: " +
          (!isOpen
            ? "Closed"
            : {
                mentee: "Mentee Editing",
                mentor: "Mentor Review",
                finalized: "Finalized"
              }[yearData.status])
      );

      $(".nextStatus, .prevStatus").hide();
      if (!isOpen) {
      } else if (yearData.status == "mentee") {
        if (menteeAccess) $(".nextStatus").show().text("Submit for Review");
      } else if (yearData.status == "mentor") {
        if (menteeAccess && !!confYearData.open)
          $(".prevStatus").show().text("Resume Editing");
        if (mentorAccess) $(".nextStatus").show().text("Finalize Review");
      } else if (yearData.status == "finalized") {
        if (mentorAccess) $(".prevStatus").show().text("Resume Review");
      }

      var getYearText = function (obj) {
        return (
          obj.getMonth() +
          1 +
          "/" +
          obj.getDate() +
          "/" +
          (obj.getFullYear() + "").slice(-2)
        );
      };
      if (isNaN(startDate)) debugger;

      $(".careerYear").html(
        "<span>" +
          getYearText(new Date(startDate)) +
          " - " +
          getYearText(new Date(endDate)) +
          "</span>" +
          (!isOpen || yearData.status == "closed"
            ? '<span class="glyphicon glyphicon-lock" style="margin-left: 10px;"></span>'
            : "")
      );

      $(".careerYearPrev")
        .css("visibility", overviewState.yearIndex > 0 ? "" : "hidden")
        .unbind("click")
        .click(function () {
          // Only go back if previous data exists
          overviewState.yearIndex--;
          updateHTML();
        });
      $(".careerYearNext")
        .toggle(overviewState.yearIndex < availableYears.length - 1)
        .unbind("click")
        .click(function () {
          overviewState.yearIndex++;
          updateHTML();
        });

      careerErrorCheck();

      $(".nextStatus")
        .unbind("click")
        .click(function () {
          if ($(this).hasClass("disabled")) {
            $(".has-error")[0].scrollIntoView();
            return;
          }
          var yearData = newDef.career[viewYear];

          var logText = JSON.stringify({
            cvOwnerId: cvOwner.id,
            userId: user.id,
            data: newDef.career
          });
          backend.send("log", logText);
          // $.get('/log?text='+encodeURIComponent(logText));

          if (yearData.status == "mentee") {
            var check = confirm(
              "Are you sure you are ready to submit? This will send a notification to your mentor that you have completed this form."
            );
            if (!check) return;
            yearData.status = "mentor";
            getKey(yearData, "statusTimes", {})[yearData.status] = Date.now();

            backend.send("sendEmail", {
              type: "mentorAlert1",
              data: {
                mentorList: mentorList,
                cvOwnerId: cvOwner.id
              }
            });
          } else if (yearData.status == "mentor") {
            var check = confirm(
              "Are you sure you are ready to finalize? This will send a notification to your mentee that you have completed this review."
            );
            if (!check) return;
            yearData.status = "finalized";
            getKey(yearData, "statusTimes", {})[yearData.status] = Date.now();

            backend.send("sendEmail", {
              type: "menteeAlert1",
              data: {
                mentorId: user.id,
                cvOwnerId: cvOwner.id
              }
            });
          }
          checkSave();
          updateHTML();
        });

      $(".prevStatus")
        .unbind("click")
        .click(function () {
          if (yearData.status == "mentor") yearData.status = "mentee";
          else if (yearData.status == "finalized") yearData.status = "mentor";
          // getKey(yearData, 'statusTimes', {})[yearData.status] = Date.now();
          checkSave();
          updateHTML();
        });

      var mghEmSectionEl = $("#MGH_EM_section");
      mghEmSectionEl.empty();

      mghEmTab.sections.map(function (mghEmSection, secI) {
        if (
          mghEmSection.edit != null &&
          isReadOnly(yearData, mghEmSection.edit)
        )
          return;

        mghEmSectionEl.append(
          $(
            '<h5 style="margin-bottom: 10px; margin-top: 20px; font-weight: bold; text-decoration: underline;">' +
              mghEmSection.name +
              "</h4>"
          )
        );

        (mghEmSection.list || []).map(function (item, itemI) {
          if (item.key == null) return;

          var readOnly = item.edit != null && isReadOnly(yearData, item.edit);

          if (item.type == null) {
            // Short text
            var text = getKey(yearData.details, item.key, "");
            mghEmSectionEl.append(
              $(
                '<div class="ACC_section" data-section="' +
                  secI +
                  '" data-item="' +
                  itemI +
                  '">' +
                  (readOnly
                    ? text
                    : '<input class="ACC_text form-control" value="' +
                      text +
                      '" style="width:50px;padding: 5px;margin-bottom: 5px;height: 30px;"/>') +
                  '<h5 style="display: inline-block;margin-left: 6px;">' +
                  item.name +
                  "</h5>" +
                  "</div>"
              )
            );
          } else if (item.type == "paragraph") {
            var text = getKey(yearData.details, item.key, "");
            mghEmSectionEl.append(
              $(
                '<div class="ACC_section" data-section="' +
                  secI +
                  '" data-item="' +
                  itemI +
                  '">' +
                  '<h5 style="display: inline-block; margin-right: 10px;">' +
                  item.name +
                  "</h5>" +
                  (readOnly
                    ? "<br>" + text
                    : "<textarea " +
                      (item.placeholder == null
                        ? ""
                        : 'placeholder="' + item.placeholder + '" ') +
                      'class="ACC_text form-control" style="min-height: 80px;">' +
                      text +
                      "</textarea>") +
                  "</div>"
              )
            );
          } else if (item.type == "select") {
            // debugger;
            var text = getKey(yearData.details, item.key, "");
            mghEmSectionEl.append(
              $(
                '<div class="ACC_section" data-section="' +
                  secI +
                  '" data-item="' +
                  itemI +
                  '">' +
                  '<h5 style="display: inline-block; margin-right: 10px;">' +
                  item.name +
                  "</h5>" +
                  '<select class="' +
                  (readOnly ? "" : "ACC_select") +
                  ' form-control" style="width: auto; margin-bottom: 10px;" ' +
                  (readOnly ? "disabled" : "") +
                  ">" +
                  item.options.map(
                    (n) =>
                      "<option " +
                      (text == n ? "selected" : "") +
                      ' value="' +
                      n +
                      '">' +
                      n +
                      "</option>"
                  ) +
                  (!item.allowOther
                    ? ""
                    : "<option " +
                      (item.options.indexOf(text) == -1 ? "selected" : "") +
                      ' value="' +
                      (item.otherName || "Other") +
                      '">' +
                      (item.otherName || "Other") +
                      "</option>") +
                  "</select>" +
                  (readOnly
                    ? !!item.allowOther && item.options.indexOf(text) == -1
                      ? "<br>" + text
                      : ""
                    : "<textarea " +
                      (item.placeholder == null
                        ? ""
                        : 'placeholder="' + item.placeholder + '" ') +
                      'class="ACC_text form-control" style="min-height: 80px;' +
                      (!!item.allowOther && item.options.indexOf(text) == -1
                        ? ""
                        : "display: none;") +
                      '">' +
                      text +
                      "</textarea>") +
                  "</div>"
              )
            );
          }
        });
      });

      $(".ACC_select")
        .unbind("change")
        .on("change", function () {
          var secI = getProp(this, "section");
          var itemI = getProp(this, "item");
          var accItem = mghEmTab.sections[secI].list[itemI];

          var newText = $(this).val();
          var otherShown =
            accItem.allowOther && accItem.options.indexOf(newText) == -1;

          $(this).parent().find(".ACC_text").toggle(otherShown).val("");

          var yearData = newDef.career[viewYear];
          yearData.details[accItem.key] = newText;
          checkSave();
        });

      $(".ACC_text")
        .unbind("input")
        .on("input", function () {
          var secI = getProp(this, "section");
          var itemI = getProp(this, "item");
          var accItem = mghEmTab.sections[secI].list[itemI];

          var newText = $(this).val();
          var yearData = newDef.career[viewYear];
          yearData.details[accItem.key] = newText;
          checkSave();
        });

      var chairSign = getKey(yearData.details, "chairSign", {});
      $("#mghEmSignChairLine").html(
        "<b>Signature of Mentor: </b><i>" +
          (chairSign.id == null
            ? "(Not Yet Signed)"
            : (users[chairSign.id] || { name: "" }).name +
              " (" +
              formatDate(new Date(chairSign.time)) +
              ")") +
          "</i>"
      );
      $("#mghEmSignChairButton")
        .toggle(!isReadOnly(yearData, "mentor", { noOverride: true }))
        .unbind("click")
        .click(function () {
          chairSign.id = user.id;
          chairSign.time = Date.now();
          refreshSection();
          $("#mghEmSignChairButton").text("Signed");
        });

      var menteeSign = getKey(yearData.details, "menteeSign", {});
      $("#mghEmSignMenteeLine").html(
        "<b>Signature of Faculty Member: </b><i>" +
          (menteeSign.id == null
            ? "(Not Yet Signed)"
            : (users[menteeSign.id] || { name: "" }).name +
              " (" +
              formatDate(new Date(menteeSign.time)) +
              ")") +
          "</i>"
      );
      $("#mghEmSignMenteeButton")
        .toggle(!isReadOnly(yearData, "mentee", { noOverride: true }))
        .unbind("click")
        .click(function () {
          menteeSign.id = user.id;
          menteeSign.time = Date.now();
          refreshSection();
          $("#mghEmSignMenteeButton").text("Signed");
        });

      $(".generalMentorComments")
        .toggle(!isReadOnly(yearData, "mentor"))
        .val(getKey(yearData, "mentorComments", ""))
        .parent()
        .toggleClass(
          "has-error",
          !isReadOnly(yearData, "mentor") &&
            (yearData.mentorComments || "").length == 0
        );

      $(".generalMentorCommentsText")
        .toggle(isReadOnly(yearData, "mentor"))
        .html(getKey(yearData, "mentorComments", "").split("\n").join("<br>"));

      $(".generalMentorComments")
        .unbind("input")
        .on("input", function () {
          var yearData = newDef.career[viewYear];
          yearData.mentorComments = $(this).val().trim();
          $(this)
            .parent()
            .toggleClass("has-error", yearData.mentorComments.length == 0);
          checkSave();
          careerErrorCheck();
        });

      updateLayout();
    };

    updateHTML();
  },
  manageSetup: function (
    settingsEl,
    { conference, updateConfDate, saveConference, hierarchyNames },
    user
  ) {
    const ccManage = new CCManage(conference, saveConference, updateConfDate, {
      includeSections: {
        cutoff: true,
        mentees: true,
        goals: false,
        questions: false,
        mentors: true,
        reminders: false,
        years: true
      },
      sortBy: "mentor",
      verbage: {
        mentor: "Mentor",
        mentee: "Mentee"
      }
    });
    ccManage.createSettingsElements(settingsEl);
    updateConfDate(conference);
    ccManage.createMentorsMenteesSection();
    ccManage.createAwesomplete();
    ccManage.hookMessageButton(user);
    ccManage.populateMenteesSection(hierarchyNames);
  }
};
